import React, { memo, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./Filters.scss";
import Filters from "./Filters";
import Button from "../Common/Button";
import FiltersIcon from "../../constants/FiltersIcon";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

const FiltersDropdown = ({
  dateProps = {},
  statusProps = {},
  otherProps = {},
  isLiveClasses = false,
  isEnableApplyButtons = false,
  applyFilters,
  resetFilters,
  isApplied = false,
  filterClass = "",
}) => {
  const dropdownRef = useRef(null);

  const handleApply = () => {
    applyFilters();
    dropdownRef?.current?.click();
  };

  const handleReset = () => {
    resetFilters();
    dropdownRef?.current?.click();
  };

  return (
    <Dropdown flip={true}>
      <Dropdown.Toggle
        id="dropdown-basic"
        as={CustomToggle}
        ref={dropdownRef}
        className="transparent-dropdown-toggle"
      >
        <div className={`filters-icon ${filterClass} mx-2`}>
          {isApplied ? (
            <FiltersIcon
              className={"mr-2"}
              style={{
                cursor: "pointer",
                backgroundColor: "transparent !important",
                border: "none !important",
                color: "blue",
              }}
              size={24}
            />
          ) : (
            <img
              style={{
                cursor: "pointer",
                backgroundColor: "transparent !important",
                border: "none !important",
              }}
              src="/Filter.svg"
              alt="Filter"
              className="mr-2"
            />
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          minHeight: "180px",
          width: "333px",
          padding: "10px",
          borderRadius: "5px",
          left: "-100px",
        }}
      >
        <Filters
          statusProps={statusProps}
          dateProps={dateProps}
          isLiveClasses={isLiveClasses}
          otherProps={otherProps}
        />
        {isEnableApplyButtons && (
          <>
            <br />
            <div className=" d-flex justify-content-between">
              <Button
                className="px-4"
                style={{
                  width: "50%",
                  height: "45px",
                  borderRadius: "5px",
                  backgroundColor: "white",
                  border: "1px solid gray",
                  color: "rgb(110, 116, 133)",
                  fontFamily: "inherit",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                onClick={handleReset}
              >
                Reset
              </Button>
              <Button
                className="px-4 save-btn"
                style={{
                  width: "50%",
                  height: "45px",
                  marginLeft: "20px",
                  cursor: "pointer",
                }}
                onClick={handleApply}
              >
                Apply
              </Button>
            </div>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(FiltersDropdown);
